import { WEBSITE_URL } from './apiBase';

function getWebsiteBase(websiteUrl = WEBSITE_URL) {
  return websiteUrl.replace(/\/$/, '');
}

export function getProductSlug(product) {
  if (!product) return '';
  return product.slug || product._id || '';
}

export function buildAffiliateLink(code, websiteUrl = WEBSITE_URL) {
  if (!code?.trim()) return '';
  return `${getWebsiteBase(websiteUrl)}/?ref=${encodeURIComponent(code.trim().toUpperCase())}`;
}

export function buildProductAffiliateLink(code, productSlug, websiteUrl = WEBSITE_URL) {
  if (!code?.trim() || !productSlug?.trim()) return '';
  return `${getWebsiteBase(websiteUrl)}/product/${encodeURIComponent(productSlug.trim())}?ref=${encodeURIComponent(code.trim().toUpperCase())}`;
}

export async function copyTextToClipboard(text) {
  await navigator.clipboard.writeText(text);
}
